import { render, staticRenderFns } from "./SpOrderBrandFilter.vue?vue&type=template&id=ea57da60&"
import script from "./SpOrderBrandFilter.vue?vue&type=script&lang=js&"
export * from "./SpOrderBrandFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports